<template>
  <div class="teacher-wrapper">
    <router-view />
    <studio-tabbar />
  </div>
</template>

<script>
import StudioTabbar from '@/components/tabbar/StudioTabbar'

export default {
  name: 'TeacherWrapper',
  components: { StudioTabbar }
}
</script>

<style scoped lang="scss">

</style>
